import React from 'react';
import { PressableProps, TouchableOpacity } from 'react-native';

type NullToUndefined<T> = {
    [K in keyof T]: null extends T[K] ? Exclude<T[K], null> | undefined : T[K];
};

/**
 * We created this separate pressable component for the web, due to some issues with onPress not being triggered every time on th WEB
 * the differences are:
 * 1. we are using TouchableOpacity instead of Pressable
 * 2. we don't support the pretty styling of the button when pressed, but the default opacity change
 */
export const Pressable = ({ style, disabled, onPress, children, ...props }: NullToUndefined<PressableProps>) => {
    const resolvedStyle = typeof style === 'function' ? style({ pressed: false }) : style;
    const resolvedChildren = typeof children === 'function' ? children({ pressed: false }) : children;

    return (
        <TouchableOpacity style={resolvedStyle} disabled={disabled} onPress={onPress} {...props}>
            {resolvedChildren}
        </TouchableOpacity>
    );
};
